<template>
  <div>

    <Head />
    <div class="layout">
      <div class="platform">
        <div class="part-1">
          <div class="main">
            <div class="left">
              <p class="tit">区块链线上交易平台</p>
              <p class="text">基于区块链技术建立安全、可靠、高效的分布式资产交易产业生态</p>
            </div>
            <div class="right">
              <img
                src="../../../assets/images/pc/solution/part1-1.png"
                alt
              />
            </div>
          </div>
        </div>
        <div class="part-2">
          <div class="main">
            <p class="tit">方案介绍</p>
            <div class="content">
              <div class="line">
                对于传统交易模式，资产流通必须依赖资产发行方系统，流通范围局限于发行方系统用户内。恒为利用区块链技术将资产流通由原来的中心化控制转变为社会化流通，任何有资源的渠道都可以成为资产流通的催化剂。
              </div>
              <div class="line">
                恒为区块链线上交易平台，通过建立分布式交易市场，使得平台管理方、买方和发行方能够以各自的身份加入本平台系统。平台支持数字资产交易（如OTC交易、合约交易等）、实物资产交易等多种交易模式，采用最新撮合交易+点对点方案，提供快速秒级交易引擎，安全、稳定、可靠。平台管理方负责系统的维护与运营，大大降低客户接入系统的成本。
              </div>
              <div class="line">
                恒为区块链线上交易平台，利用区块链“交易即结算”的基本特性使得实时清算成为可能，大幅提高交易处理效率，实现资产流通情况的实时查询。在资产发行与流通网络中，通过区块链实现资产登记、交易确认、记账对账和清算等功能。
              </div>
              <div class="line">
                方案适用于数字资产交易、能源交易、版权交易、奢侈品交易、艺术品交易、精准扶贫等众多场景。
              </div>
              <div class="img">
                <img
                  src="../../../assets/images/pc/solution/onlineTrad/part2.png"
                  alt=""
                >
              </div>
            </div>
          </div>
        </div>
        <div class="part-3">
          <div class="main">
            <p class="tit">方案价值</p>
            <div class="content">
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/solution/onlineTrad/part3-1.png"
                    alt=""
                  >
                </div>
                <div class="right">
                  <p class="title">平台管理方受益</p>
                  <p class="txt">基于区块链的分布式技术特性，恒为区块链线上交易平台天然地具有安全、可靠、可信任属性。平台线上交易真实有效、可查询追溯，能有效解决传统交易平台数据不透明、数据造假、中心化平台易受攻击等问题，极大地降低了投资风险</p>
                </div>
              </div>
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/solution/onlineTrad/part3-2.png"
                    alt=""
                  >
                </div>
                <div class="right">
                  <p class="title">发行方受益</p>
                  <p class="txt">将拥有更多的发行资产受众，资产上链，确保了资产的唯一性；智能合约撮合交易实现变现，每笔交易链上可查，避免纠纷；秒级交易“实时结算”，有效解决对账繁琐、效率低等问题</p>
                </div>
              </div>
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/solution/onlineTrad/part3-3.png"
                    alt=""
                  >
                </div>
                <div class="right">
                  <p class="title">买方受益</p>
                  <p class="txt">资产信息真实可靠，交易透明、可追溯</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/pc/Head";
import Foot from "../../../components/pc/Foot";
import api from "../../../common/api";
import { Button } from "iview";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "service",
  components: {
    Head,
    Foot,
    Button,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      cn: false,
      en: false,
      swiperOptions: {
        //swiper配置
        //autoplay: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //分页控制切换
        },
        // Some Swiper option/callback...
      },
    };
  },
  mounted() {
    this.mobile();
  },
  created() {
    this.getLang();
  },
  methods: {
    getLang() {
      if (localStorage.Lang == "en") {
        this.en = true;
      } else {
        this.cn = true;
      }
    },
    mobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if ((flag && flag.length) > 0) {
        this.$router.replace("/mobile" + this.$route.path);
      }
    },
  },
};
</script>
<style  lang="less"  scoped>
@import url("../../../assets/css/var.less");
.layout {
  min-height: calc(100vh);
  // max-width:@max-width;
  min-width: @min-width;
  background-color: #f8f9fb;
}
.platform {
  .part-1 {
    width: 100%;
    .p1();
    background: linear-gradient(-30deg, #4d23ee, #4697fb);
    .main {
      .clearfix();
    }
    .left {
      width: 54%;
      float: left;
      .tit {
        .hTit();
        margin: 185px 0 25px 0;
      }
      .text {
         width: 510px;
        .hText();
      }
    }
    .right {
      width: 46%;
      float: left;
      img {
        margin: 62px 0 0 75px;
        width: 400px;
        height: 384px;
      }
    }
  }
  .part-2 {
    background: #fff;
    padding: 80px 0 80px;
    .main {
      .clearfix();
      height: 100%;
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        width: 100%;
        height: 100%;
        .line {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 15px;
        }
        .img {
          margin-top: 35px;
          text-align: center;
         img {
            width: 814px;
            height: auto;
          }
        }
      }
    }
  }

  .part-3 {
    padding: 80px 0 80px;
    background: #f9f9f9;
    .main {
      .clearfix();
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        width: 100%;
        .card {
          width: 1140px;
          height: 184px;
          display: flex;
          padding: 38px 20px;
          background: #ffffff;
          margin: 15px auto;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          .left {
            width: 179px;
            img {
              height: 100%;
              height: 108px;
            }
          }
          .right {
            padding: 25px 0 0 20px;

            .title {
              color: #444444;
              font-size: 20px;
              text-align: left;
              margin-bottom: 4px;
            }
            .txt {
              color: #888888;
              text-align: left;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .part-4 {
    padding: 80px 0 80px;
    background: #ffffff;
    .main {
      .clearfix();
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        display: flex;
        flex-wrap: wrap;
        .card {
          height: 332px;
          background: #fff;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          margin: 10px;
          padding: 10px;
          display: flex;
          .left {
            width: 447px;
            img {
              height: 100%;
              width: 100%;
            }
          }
          .right {
            flex: 1;
            padding: 45px 42px 0 59px;
            .l1 {
              color: #444444;
              font-size: 20px;
            }
            .l2 {
              margin: 30px 0;
              color: #888888;
              font-size: 14px;
              line-height: 24px;
            }
            .l3 {
              color: #888888;
              font-size: 14px;
              height: 32px;
              span {
                display: inline-block;
                height: 32px;
                line-height: 32px;
              }
              img {
                vertical-align: top;
                width: 32px;
                height: 32px;
              }
              .s3 {
                margin-left: 30px;
              }
            }
          }
        }
        .swiper-pagination {
          position: static; //取消定位
          display: block;
          margin: 30px auto 0;
          /deep/.swiper-pagination-bullet {
            background: #d4d4d4;
            margin: 0 5px;
            opacity: 1;
            outline: none; //清除点击突出的边框
          }
          /deep/.swiper-pagination-bullet-active {
            background: #2a93ff;
            position: relative;
            top: -2px;
            width: 28px;
            height: 4px;
            border-radius: 5px;
            opacity: 1;
            outline: none;
          }
        }
      }
    }
  }
}
</style>